module.exports = __webpack_public_path__ + "static/Vons_pin_hover-f880fd4ca76647d527cf16c2e3ffc525.png";